import { render, staticRenderFns } from "./TemplateWidget.vue?vue&type=template&id=5d0e3cf2&"
import script from "./TemplateWidget.vue?vue&type=script&lang=ts&"
export * from "./TemplateWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports